/** @format */

import type { AnimationItem } from "lottie-web";
import lottie from "lottie-web/build/player/lottie_light.min.js";
import type React from "react";
import { FC, memo, useEffect, useRef } from "react";
import styled from "styled-components";
import SurveyGuideArea from "../../../assets/lottieFiles/surveyGuide-area.json";
import SurveyGuidePath from "../../../assets/lottieFiles/surveyGuide-path.json";
import SurveyGuidePoints from "../../../assets/lottieFiles/surveyGuide-points.json";

interface SurveyGuideAnimationProps {
  id?: string;
  width?: string;
  height?: string;
  color?: string;
  type?: "point" | "path" | "area";
}

export const SurveyGuideAnimation: React.FC<SurveyGuideAnimationProps> = ({
  id,
  width = "200px",
  height = "30%",
  color,
  type = "point",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let animation: AnimationItem | null = null;

    const loadAnimation = async () => {
      if (containerRef.current && containerRef.current.children.length === 0) {
        animation = lottie.loadAnimation({
          container: containerRef.current,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData:
            type === "point"
              ? SurveyGuidePoints
              : type === "path"
                ? SurveyGuidePath
                : SurveyGuideArea,
        });
      }
    };

    loadAnimation();

    return () => {
      if (animation) {
        animation.destroy();
      }
    };
  }, [type]);

  return (
    <div
      id={id || "SurveyGuideAnimation"}
      className="relative scale-[300%]"
      style={{
        width: width || "70%",
        height: height || "70%",
        fill: color || "inherit",
      }}
      color={color}
      ref={containerRef}
    />
  );
};

export default memo(SurveyGuideAnimation);
